module.exports = __webpack_public_path__ + "static/media/cities.e34b765c.jpg";